import React from 'react';
import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';

import msg from '@salesforce/retail-react-app/app/components/display-price/messages';
import {Text, VisuallyHidden} from '@salesforce/retail-react-app/app/components/shared/ui';
import {normalizeMyrCurrencyDisplay} from '@amblique/king-living/app/utils/format-currency-hide-zero-cents';

/**
 * @override Remove MYR symbol/amount space for en-MY parity with live SFCC (KINDW-658).
 */
const ListPrice = ({labelForA11y, price, isRange = false, as = 's', currency, ...extraProps}) => {
  const intl = useIntl();
  const listPriceText = normalizeMyrCurrencyDisplay(
    intl.formatNumber(price, {
      style: 'currency',
      currency,
    }),
    currency
  );

  return (
    <>
      {isRange ? (
        <Text
          as={as}
          color="gray.600"
          {...extraProps}
          aria-label={intl.formatMessage(msg.ariaLabelListPriceWithRange, {
            listPrice: listPriceText || '',
          })}
        >
          {listPriceText}
        </Text>
      ) : (
        <Text
          as={as}
          color="gray.600"
          {...extraProps}
          aria-label={intl.formatMessage(msg.ariaLabelListPrice, {
            listPrice: listPriceText || '',
          })}
        >
          {listPriceText}
        </Text>
      )}
      <VisuallyHidden aria-atomic={true} aria-live="polite">
        {labelForA11y}
        {intl.formatMessage(msg.ariaLabelListPrice, {
          listPrice: listPriceText || '',
        })}
      </VisuallyHidden>
    </>
  );
};

ListPrice.propTypes = {
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  labelForA11y: PropTypes.string,
  as: PropTypes.string,
  isRange: PropTypes.bool,
  extraProps: PropTypes.object,
};

export default ListPrice;
